import gql from './index';

interface GetResponse<Records> {
  table: Records[];
}

export default <ReturnFields>(
  tableName: string,
  returnFields: string,
) => gql<GetResponse<ReturnFields>>(`
  query ${tableName}(
    $id: uuid!
  ) {
    table: ${tableName}(
      limit: 1
      where: {
        id: {
          _eq: $id
        }
      }
    ) {
      ${returnFields}
    }
  }
`);
